import React, { Component } from 'react';
import PubSub from 'pubsub-js';

import TOOLS from './TOOLS';

import Header from './Header';
import AppsEmDestaque from './AppsEmDestaque';
import GaleriaDeApps from './GaleriaDeApps';
import Footer from './Footer';
import AdSenseFeed from './AdSenseFeed';

//style
import '../css/IndexPage.css';

class IndexPage extends Component {
  constructor() {
    super();
    this.state = {
      serverResponse: false,
      lang: "en",
      appsDestaque: [],
      apps: []
    };

    this.locationTexts= {
      "carregando" : {"pt" : "Carregando...", "es": "Cargando...", "en": "Loading..."}
    };
  }

  getApps() {
    fetch(`${TOOLS.siteURL}/api/`)
      .then(response => response.json())
      .then(json => {
        if(json.ok){
          this.setState({ serverResponse: true });

          let appsDestaque = json.apps.filter(app => app.featured);
          let apps = json.apps.filter(app => !app.featured);

          this.setState({ apps, appsDestaque });
        }else{
          window.alert(json.message);
        }
      });
  }

  componentWillMount() {
    PubSub.subscribe('language.change', (msg, lang) => this.setState({lang}));

    let getLang;
    getLang = new Promise((resolve, reject) => {
      let lang = "en";
      if (this.props.match.params.lang) {
        lang = this.props.match.params.lang;
      } else {
        let navLang = navigator.language.toLowerCase();
        let vetLangs = ["pt", "en", "es"];

        for (let i = 0; i < vetLangs.length; i++) {
          if (navLang.search(vetLangs[i]) !== -1) {
            lang = vetLangs[i];
            break;
          }
        }

      }
      resolve(lang);
    });
    getLang.then(lang => {
      PubSub.publish("language.change", lang);
      this.setState({ lang });
      this.getApps();
    });
  }

  render() {
    let texts= this.locationTexts;
    if (this.state.serverResponse) {
      return (
        <div>
          <Header />
          <AppsEmDestaque lang={this.state.lang} apps={this.state.appsDestaque} />
          <div style={ {textAlign:"center"} } >
            <AdSenseFeed />
          </div>  
          <GaleriaDeApps lang={this.state.lang} apps={this.state.apps} />
          <Footer />
        </div>
      );
    } else {
      return (
        <div id="indexPage-DivPai">
          <Header />
          <div className="textLoading">{texts["carregando"][this.state.lang]}</div>
          <Footer />
        </div>
      );
    }

  }
}

export default IndexPage;



// WEBPACK FOOTER //
// ./src/componentes/IndexPage.js